module.exports = __webpack_public_path__ + "img/modifiers.6a60a499.svg";